import { AfterContentInit, ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, PLATFORM_ID, viewChild } from '@angular/core';
import { CdkPortal } from '@angular/cdk/portal';
import { ToolbarPortalService } from '../toolbar-portal.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'oo-bar-bottom-row',
  templateUrl: './bar-bottom-row.component.html',
  styleUrls: ['./bar-bottom-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkPortal],
})
export class BarBottomRowComponent implements OnInit, AfterContentInit, OnDestroy {
  readonly portalWrapper = viewChild.required(CdkPortal);
  private readonly toolbarPortalService = inject(ToolbarPortalService);
  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    this.toolbarPortalService.setBottomPortal(this.portalWrapper());
  }

  ngAfterContentInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.dispatchEvent(new Event('resize'));
    }
  }

  ngOnDestroy(): void {
    this.toolbarPortalService.unsetBottomPortal();
  }
}
